import React from 'react';

import s from './Badge.module.scss';

const Badge = ({ text }: { text: string }) => (
  <div className={s.badge}>{text}</div>
);

export default Badge;
